import actions from './actions'
import mutations from './mutation'

const state = {
  node_list: [],
  node_paging: {
    offset: 0,
    limit: 10,
    total: 0
  }
}

export default {
  state,
  actions,
  mutations
}
